import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'day-trade',
    templateUrl: 'day-trade.component.html',
    styleUrls: ['./day-trade.component.scss']
})

export class DayTrade implements OnInit{

    private readonly productAreaOrigin = 'Home';
    private readonly product = 'Curso Day Trade para iniciantes';
    private readonly scenario = 'Trader';
    private readonly status = 'Aberta';
    private readonly timeResponsavel = 'Sky';
    private readonly notApplicable = 'Não se aplica';

    constructor(
        private store: Store<any>,
        private router: Router
    ) {}

    public ngOnInit() {
        this.sendTracking("Page Loaded", {
            'Product Area Origin': this.productAreaOrigin,
            'Status': this.status,
            'Scenario': this.scenario,
            'Step': this.product,
            'Time Responsável': this.timeResponsavel,
            'Current URL': '/lp-curso-daytrade-iniciantes',
        });
    }

    public navigateTo(path: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': this.productAreaOrigin,
            'Element': 'Botão Transferir',
            'Group': this.notApplicable,
            'Step': this.product,
            'Scenario': this.scenario,
            'Status': this.status,
            'Label': this.notApplicable,
            'Text': this.notApplicable,
            'Time Responsável': this.timeResponsavel,
        });

        this.router.navigate([path]);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}